import AAudioPlayerProgressBar from './index.vue';

AAudioPlayerProgressBar.install = app => {
  app.component(AAudioPlayerProgressBar.name, AAudioPlayerProgressBar);
};

export default AAudioPlayerProgressBar;
